export default __webpack_public_path__ + "static/media/10.ffe4457c.gif";